/**
 * This file is for adding in constants from webpack. Since webpack pulls
 * in the definition of the value every time it is referenced, it will be
 * easier to define them here, and then reference them as an import elsewhere.
 */

export default process.env


// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/utils/constants.js